
        
jQuery(document).ready(function() {

	if (jQuery('section[class^=section-inventaires]').html() !== undefined) {
		// Méthodes JavaScript communes
		require('./functions/validators.functions');
		// Méthodes jQuery communes
		require('./jquery/clients.jquery');
		require('./jquery/documents.jquery');
		require('./jquery/upload.jquery');
		//#####################################################
        // Dropdown filters
        //#####################################################
        var titleFilter = document.querySelector('.inventories-title');
        var inventoriesFilter = document.querySelector('.inventories-filters');

        // Add a click event to the title element
        $(titleFilter).on('click', function() {
            // Toggle the "open" class on the filters element
            $(inventoriesFilter).toggleClass('open');
            $(titleFilter).toggleClass('active');
        });

        var myModal = $('#myModal');
        var myInput = $('#myInput');

        if (myModal.length) {
            myModal.on('shown.bs.modal', function() {
                myInput.focus();
            });
        }

        //#####################################################
        // Send copy quote url to the modale form action
        //#####################################################
        $('button.copy-quote-btn').on('click', function() {
            $('form#confirm-copy-quote').attr('action', $(this).data('url'));
            $('.modal_reference_number').text($(this).data('ref'));
        });

        //#####################################################
        // Send cancel quote url to the modale form action
        //#####################################################
        $('button.cancel-quote-btn').on('click', function() {
            $('form#confirm-cancel-quote').attr('action', $(this).data('url'));
            $('.modal_reference_number').text($(this).data('ref'));
        });

	}
	})